<script>
    import { onMount } from "svelte";

    import {
        checkAbnValidation,
        getBankAccountNumberValidation,
        getBsbValidation,
    } from "../../../Utils/utilFunctions.svelte";

    export let personalDetails = {};
    export let updatePersonalDetailsPhase = () => {};

    $: isAhpraIdValid = profile.ahpra ? profile.ahpra.length > 3 : false;

    $: isAccountNameValid = profile.bankAccountName
        ? profile.bankAccountName.length > 0
        : false;

    $: isBsbValid = getBsbValidation(profile.bankAccountBSB);

    $: isAccountNumberValid = getBankAccountNumberValidation(
        profile.bankAccountNumber,
    );

    $: isAbnValid = checkAbnValidation(profile.abn);

    let profile = {};

    onMount(() => {
        if (personalDetails.hasOwnProperty("profile"))
            profile = { ...personalDetails.profile };

        if (profile.ahpra && profile.ahpra.substring(0, 3) === "MED")
            profile.ahpra = profile.ahpra.replaceAll("MED", "");
    });

    const updatePersonalDetails = () => {
        if (!_checkFieldsValidation()) return;

        if (profile.ahpra) profile.ahpra = profile.ahpra.replaceAll("MED", "");

        profile.ahpra = "MED" + (profile.ahpra ? profile.ahpra : "");

        personalDetails.profile = { ...profile };

        updatePersonalDetailsPhase(4);
    };

    // HELPER FUNCTIONS
    const _checkFieldsValidation = () => {
        _updateInvalidFieldsStyle();

        return (
            profile.ahpra &&
            isAhpraIdValid &&
            profile.bankAccountName &&
            isAccountNameValid &&
            profile.bankAccountBSB &&
            isBsbValid &&
            profile.bankAccountNumber &&
            isAccountNumberValid &&
            isAbnValid
        );
    };

    const _updateInvalidFieldsStyle = () => {
        if (!profile.ahpra || !isAhpraIdValid) _setErrorStyle("ahpraInput");
        else _resetDefaultStyle("ahpraInput");

        if (!profile.bankAccountName || !isAccountNameValid)
            _setErrorStyle("accountNameInput");
        else _resetDefaultStyle("accountNameInput");

        if (!profile.bankAccountBSB || !isBsbValid)
            _setErrorStyle("accountBsbInput");
        else _resetDefaultStyle("accountBsbInput");

        if (!profile.bankAccountNumber || !isAccountNumberValid)
            _setErrorStyle("accountNoInput");
        else _resetDefaultStyle("accountNoInput");

        if (!isAbnValid) _setErrorStyle("abnInput");
        else _resetDefaultStyle("abnInput");
    };

    const _setErrorStyle = (id) => {
        const field = document.getElementById(`${id}`);
        field.style.outline = "red solid 2px";
    };

    const _resetDefaultStyle = (id) => {
        const field = document.getElementById(`${id}`);
        field.style.outline = "none";
    };
</script>

<p class="text-[16px] text-gray-600">
    Now we need to collect information about your medical registration and
    banking
</p>

<form
    on:submit|preventDefault={updatePersonalDetails}
    novalidate
    class="flex flex-col gap-y-4 p-4 w-full"
>
    <div class="flex flex-col gap-y-2">
        <label
            for="AhpraID"
            class="mandatory leading-7 text-sm text-gray-600 font-bold text-[16px]"
        >
            AHPRA ID number
        </label>

        <div class="flex items-center w-full">
            <span class="font-bold px-2 py-1 bg-[#fff]"> MED </span>
            <input
                type="text"
                name="AhpraID"
                class="input input-sm w-full pl-0"
                id="ahpraInput"
                autocomplete="off"
                placeholder=""
                bind:value={profile.ahpra}
                on:focus={() => _resetDefaultStyle("ahpraInput")}
            />
        </div>
    </div>

    <div class="divider" />

    <p class="leading-7 text-sm text-gray-600 font-bold text-[20px]">
        Your banking details
    </p>

    <div class="flex flex-col gap-y-2">
        <label
            for="accountName"
            class="mandatory leading-7 text-sm text-gray-600 font-bold text-[16px]"
        >
            Account Name
        </label>

        <input
            type="text"
            name="accountName"
            class="input input-sm"
            id="accountNameInput"
            autocomplete="off"
            bind:value={profile.bankAccountName}
            on:focus={() => _resetDefaultStyle("accountNameInput")}
        />
    </div>

    <div class="flex flex-col gap-y-2">
        <label
            for="BsbNumber"
            class="mandatory leading-7 text-sm text-gray-600 font-bold text-[16px]"
        >
            BSB Number
        </label>

        <input
            type="text"
            name="BsbNumber"
            class="input input-sm"
            id="accountBsbInput"
            autocomplete="off"
            bind:value={profile.bankAccountBSB}
            on:focus={() => _resetDefaultStyle("accountBsbInput")}
        />
    </div>

    <div class="flex flex-col gap-y-2">
        <label
            for="accountNumber"
            class="mandatory leading-7 text-sm text-gray-600 font-bold text-[16px]"
        >
            Account number
        </label>

        <input
            type="text"
            name="accountNumber"
            class="input input-sm"
            id="accountNoInput"
            autocomplete="off"
            bind:value={profile.bankAccountNumber}
            on:focus={() => _resetDefaultStyle("accountNoInput")}
        />
    </div>

    <div class="divider" />

    <div class="flex flex-col gap-y-2">
        <label
            for="abnNumber"
            class="mandatory leading-7 text-sm text-gray-600 font-bold text-[16px]"
        >
            ABN
        </label>

        <input
            type="text"
            name="abnNumber"
            class="input input-sm"
            id="abnInput"
            autocomplete="off"
            bind:value={profile.abn}
            on:focus={() => _resetDefaultStyle("abnInput")}
        />
    </div>

    <div class="divider" />

    <p class="leading-7 text-sm text-gray-600 font-bold text-[20px]">
        Optional details
    </p>

    <div class="flex flex-col gap-y-2">
        <label
            for="qualification"
            class="leading-7 text-sm text-gray-600 font-bold text-[16px]"
        >
            Qualifications
        </label>

        <input
            type="text"
            name="qualification"
            class="input input-sm"
            placeholder="e.g. MBBS FANZCA"
            autocomplete="off"
            bind:value={profile.qualifications}
        />
    </div>

    <div class="flex w-full">
        <button
            class="btn btn-sm btn-secondary w-full"
            on:click|preventDefault={updatePersonalDetails}
        >
            Next
        </button>
    </div>
</form>

<style>
    .mandatory::before {
        content: " * ";
    }
</style>
